export default class extends HTMLElement {
  connectedCallback () {
    this.addEventListener('mouseenter', this.onMouseenter)
    this.addEventListener('focusin', this.onFocusin)
  }

  disconnectedCallback () {
    this.removeEventListener('mouseenter', this.onMouseenter)
    this.removeEventListener('focusin', this.onFocusin)
  }

  onMouseenter = () => {
    this.searchModal?.init()
  }

  onFocusin = () => {
    if (navigator.userActivation?.hasBeenActive === false) return

    this.searchModal?.open()
  }

  get searchModal () {
    return document.querySelector('search-modal')
  }
}
